import List from "@/components/list";
const Table = args => {
  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "answererName"
    },
    {
      label: "工作单位",
      prop: "deptName"
    },
    {
      label: "职务",
      prop: "position"
    },
    {
      label: "填写内容",
      prop: "answer"
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};

export default Table;
